class ApiConstant {
    static BASE_URL = "https://linking-backend.sujithsureshkumar081.workers.dev";
    static API = "/api";
    static API_KEY = "1234567890";
    static TIMEOUT = 5000;
}

export default ApiConstant;
